<template>
  <div>
    <pdf
      v-for="i in numPages"
      :key="i"
      :src="src"
      :page="i"
    />
  </div>
</template>

<script>
import pdf from 'vue-pdf';

export default {
  name: 'UserTerms',
  components: {
    pdf
  },
  data: () => ({
    src: pdf.createLoadingTask('https://tippiie-images.s3.eu-central-1.amazonaws.com/public/tippie-user-terms.pdf'),
    numPages: 1
  }),
  mounted () {
    this.src.promise.then(pdf => {
      this.numPages = pdf.numPages;
    });
  }
};
</script>

<style scoped>

</style>
